import React from 'react';
import { useTranslation } from 'react-i18next';

import { OpenClass } from '../types/OpenClass';
import {
  formatOpenClassDateRange,
  formatOpenClassLocation,
  uniqueSessionLocations,
} from '../utils/openClass';

const OpenClassDateAndLocation: React.FC<{ openClass: OpenClass }> = ({
  openClass,
}) => {
  const { t } = useTranslation();
  const locations = uniqueSessionLocations(openClass.sessions);

  return (
    <div>
      <div className="whitespace-nowrap">
        {formatOpenClassDateRange(openClass)}
      </div>
      {locations.length > 0 && (
        <div className="text-xs text-blueGrayDark" title={locations[0]}>
          {formatOpenClassLocation(locations[0])}
          {locations.length > 1 &&
            ` · ${t('views.OpenClasses.locationsMore', {
              count: locations.length - 1,
            })}`}
        </div>
      )}
    </div>
  );
};

export default OpenClassDateAndLocation;
